const IMAGE_FILE_TYPE = ['image/jpeg', 'image/png', 'image/jpg']; // JPG-PNG
export const MAX_FILE_SIZE_UPLOAD = 100 * 1024 * 1024; // 100MB
export const ALL_IMAGE_FILE_TYPE = 'image/*';
export const PDF_FILE_TYPE = 'application/pdf';
export const ALLOWED_FILE_TYPES_UPLOAD = [
    'application/vnd.oasis.opendocument.spreadsheet', // .ods, .xls, .xlsx
    'application/vnd.google-apps.spreadsheet', // .gsheet, .xls, .xlsx
    'application/vnd.google-apps.document', // .gdoc, .doc, .docx
    'application/msword', // .doc, .docx
    'application/rtf', // .rtf
    'text/plain', // .txt
    'application/vnd.ms-excel', // .xls, .xlsx
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'text/rtf', // this may vary depending on the ".document" type
    'text/html', // .html
    'text/csv', // .csv
    'application/vnd.apple.numbers', // .numbers
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    ALL_IMAGE_FILE_TYPE, // All images
    PDF_FILE_TYPE,
    ...IMAGE_FILE_TYPE,
];
export const EMPLOYEE_ALLOWED_FILE_TYPES_UPLOAD = [...ALLOWED_FILE_TYPES_UPLOAD, '.bck'];
export const MIN_NUMBER_OF_FILES = 1;
